import { render } from "./BaseShadowCard.vue?vue&type=template&id=05068e6c&scoped=true&ts=true"
import script from "./BaseShadowCard.vue?vue&type=script&lang=ts"
export * from "./BaseShadowCard.vue?vue&type=script&lang=ts"

import "./BaseShadowCard.vue?vue&type=style&index=0&id=05068e6c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05068e6c"]])

export default __exports__